<svg width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M14 19C15.1046 19 16 18.1046 16 17C16 15.8954 15.1046 15 14 15C12.8954 15 12 15.8954 12 17C12 18.1046 12.8954 19 14 19Z"
    fill="#202020"
  />
  <path
    d="M21 19C22.1046 19 23 18.1046 23 17C23 15.8954 22.1046 15 21 15C19.8954 15 19 15.8954 19 17C19 18.1046 19.8954 19 21 19Z"
    fill="#202020"
  />
  <path
    d="M28 19C29.1046 19 30 18.1046 30 17C30 15.8954 29.1046 15 28 15C26.8954 15 26 15.8954 26 17C26 18.1046 26.8954 19 28 19Z"
    fill="#202020"
  />
  <path
    d="M25.3686 11.8728H28.3501C27.4794 9.77527 25.7908 8.0735 23.6273 7.21602C22.994 3.10012 19.4453 0 15.1711 0C10.6329 0 6.89953 3.54864 6.6225 8.02073C4.99985 8.28457 3.50913 9.04971 2.30864 10.237C0.83111 11.7409 0 13.7197 0 15.8304C0 20.1969 3.5619 23.7456 7.91533 23.7456H14.3794L11.7411 21.1073L7.91533 21.1072C5.01304 21.1072 2.63844 18.7458 2.63844 15.8304C2.63844 14.4188 3.19252 13.0996 4.18193 12.0971C5.18454 11.1077 6.51696 10.5536 7.95491 10.5536H9.44563L9.27413 9.07609C9.24775 8.91779 9.23456 8.74629 9.23456 8.57479C9.23456 5.30318 12.0049 2.6384 15.1711 2.6384C18.3372 2.6384 20.9361 5.1053 21.0812 8.25819L21.1339 9.20801L22.0574 9.45866C23.4426 9.84123 24.6035 10.7251 25.3686 11.8728Z"
    fill="#202020"
  />
</svg>
